import React from "react";
import {Container} from "react-bootstrap";
import {headingStyles, regularTextStyles} from "../Style";

const AgeOfVehicleErrorPage = props => {
  return (
    <Container style={{paddingBottom: "110px"}}>
      <>
        <br/>
        <br/>
        <p style={headingStyles}>Sorry!<br/> <span style={regularTextStyles}>While we can provide insurance for most cars, we can’t insure this vehicle.</span>

        </p>
        <br/><br/><br/><br/>


      </>
    </Container>
  );
}

export default AgeOfVehicleErrorPage;
